import PropTypes from 'prop-types';
import moment from 'moment';

import JawsComponent from 'components/JawsComponent';

import jawsConnect from 'utils/jawsConnect';

import {
  getSelectedAccount,
  getAvailableVolume,
  getCustomerNumber,
} from 'utils/customer';
import { getCustomerData } from 'utils/user';

if (process.env.NODE_ENV !== 'test') {
  require('./InventoryQuote.scss');
}

class InstrumentFetcher extends JawsComponent {
  spec = {
    columns: 'ITEM_SECTOR,ITEM,LAST,LASTNZ_CA,CHANGE,CHANGE_PCT,TIME',
  };

  state = {
    vol: 0,
  };

  portfolioId = null;

  static propTypes = {
    item: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { ITEM, SECTOR } = this.props.item;
    if (ITEM && SECTOR) {
      this.fetchAvailableVolume(ITEM, SECTOR);

      this.spec.itemSector = `${ITEM}.${SECTOR}`;
      super.componentDidMount();
    }
  }

  componentWillReceiveProps({ item }) {
    const { ITEM: oldItem } = this.props.item;
    const { user } = this.props;
    const customer = getCustomerData(user);
    const selectedAccount = getSelectedAccount(customer);
    const newPortfolioId = selectedAccount.get('customerId');

    // Update when selected item or selected account changes
    if (oldItem !== item.ITEM || this.portfolioId !== newPortfolioId) {
      this.fetchAvailableVolume(item.ITEM, item.SECTOR);
      this.portfolioId = newPortfolioId;

      this.spec.itemSector = `${item.ITEM}.${item.SECTOR}`;
      this.resubscribe();
    }
  }

  fetchAvailableVolume(item, sector) {
    const { user } = this.props;
    const customerId = getSelectedAccount(getCustomerData(user)).get(
      'customerId',
    );

    getAvailableVolume(getCustomerNumber(user), customerId, item, sector).end(
      (err, res) => {
        if (err) throw new Error('InventoryQuote.fetchAvailableVolume: ' + err);

        this.setState({ vol: res.body.data.availableVolume });
      },
    );
  }

  render() {
    const { items } = this.props;
    const { ITEM, LAST, LASTNZ_CA, CHANGE, CHANGE_PCT, TIME } = items.first()
      ? items.first().values
      : {};
    const formattedTime = TIME ? moment(TIME).format('HH:mm:ss') : '-';

    return this.props.render({
      ticker: ITEM,
      holding: this.state.vol,
      last: LAST,
      lastnz_ca: LASTNZ_CA,
      change: CHANGE,
      changePct: CHANGE_PCT,
      formattedTime,
    });
  }
}

export { InstrumentFetcher };
export default jawsConnect(InstrumentFetcher);
